module.exports = __webpack_public_path__ + "media/images/emblems/Schwellb-6961d9638c5d0f51f3a50bec9c384033.png";